import { Record, Map } from 'immutable';

const RootRecord = Record({
  _links: new Map(),
  _forms: new Map()
});

class Root extends RootRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Root;


// WEBPACK FOOTER //
// ./src/api/models/root.js